var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-seo w-100 d-inline-block mt-4"},[_c('div',{class:{
            'input-focus-effect': true,
            'rv-valiadate-input-form': _vm.error
        }},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail_seo),expression:"detail_seo"}],class:_vm.detail_seo != '' ? 'border-primary' : '',attrs:{"id":"inputOtherInfo","rows":"3"},domProps:{"value":(_vm.detail_seo)},on:{"focus":_vm.forcusTextArer,"input":function($event){if($event.target.composing)return;_vm.detail_seo=$event.target.value}}}),_c('label',{class:{
                'mb-0': true,
                'input-on-alue': _vm.detail_seo != ''
            }},[_vm._v("Nhập mô tả SEO")])]),(_vm.error)?_c('div',{staticClass:"text-danger fs-12px mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }